module.exports = __webpack_public_path__ + "img/Comic02-3.b0690c7c.png";